import { Identifiable, Zone, ZoneProjectsRetrievalFilter } from "@planzone/dto";
import { zoneProjectsRetrievalError } from "@planzone/dto";
import { areZoneProjectsRetrievalFilters } from "../../utils/areZoneProjectsRetrievalFilters";
import { SearchResult, State } from "./types";

function getZoneState(
  state: State,
  {
    zone,
    filter,
  }: { zone: Identifiable<Zone>; filter: ZoneProjectsRetrievalFilter },
): { result: SearchResult; index: number } {
  const index = state.findIndex(
    (res) =>
      res.zone.uuid === zone.uuid &&
      areZoneProjectsRetrievalFilters(filter, res.filter),
  );

  return {
    index,
    result:
      index !== -1
        ? state[index]
        : {
            zone,
            filter,
            projects: [],
            request: {
              isPending: false,
              isSuccessful: false,
              isFailure: false,
            },
            callCount: 0,
            error: zoneProjectsRetrievalError,
            canRetrieveNextProjects: true,
          },
  };
}

export { getZoneState };
